import Leads from '@/views/Leads/LeadIndex.vue';
import LeadStreams from '@/views/Leads/Stream/LeadStreamIndex.vue';
import LendingTreeLeads from '@/views/Leads/Lendingtree/LendingtreeLeadIndex.vue';
import LeadServicing from '@/views/Leads/Servicing/LeadServicingIndex.vue';
import LeadProviderIndex from '@/views/Leads/LeadProvider/LeadProviderIndex.vue';
import CampaignIndex from '@/views/Leads/Campaign/CampaignIndex.vue';
import CampaignTestingIndex from '@/views/Leads/CampaignTesting/CampaignTestingIndex.vue';
import PrescreenCampaignIndex from '@/views/Leads/Prescreen/Campaign/PrescreenCampaignIndex.vue';
import PrescreenFileIndex from '@/views/Leads/Prescreen/FileManagement/PrescreenFileIndex.vue';
import PrescreenFileDetails from '@/views/Leads/Prescreen/FileManagement/PrescreenFileDetails.vue';

export default [
  {
    path: 'leads',
    name: 'leads',
    component: Leads,
    meta: {
      title: 'Leads',
      permission: 'view lead',
    },
    children: [
      {
        path: 'streams',
        name: 'lead-streams',
        component: LeadStreams,
        meta: {
          title: 'Streams',
          permission: 'view lead::stream',
        },
      },
      {
        path: 'lendingtree',
        name: 'lendingtree-leads',
        component: LendingTreeLeads,
        meta: {
          title: 'Lendingtree',
          permission: 'view lead::lending-tree',
        },
      },
      {
        path: 'servicing',
        name: 'lead-servicing',
        component: LeadServicing,
        meta: {
          title: 'Servicing',
          permission: 'view lead::servicing',
        },
      },
      {
        path: 'lead-providers',
        name: 'lead-providers',
        component: LeadProviderIndex,
        meta: {
          title: 'Lead Providers',
          permission: 'view lead::lead-providers',
        },
      },
      {
        path: 'campaigns',
        name: 'campaigns',
        component: CampaignIndex,
        meta: {
          title: 'Campaigns',
          permission: 'view lead::campaigns',
        },
      },
      {
        path: 'campaign-testing',
        name: 'campaign-testing',
        component: CampaignTestingIndex,
        meta: {
          title: 'Campaign Testing',
          permission: 'view lead::campaigns',
        },
      },
      {
        path: 'prescreen-campaigns',
        name: 'prescreen-campaigns',
        component: PrescreenCampaignIndex,
        meta: {
          title: 'Prescreen Campaigns',
          permission: 'view prescreen::campaign',
        },
      },
      {
        path: 'prescreen-files',
        name: 'prescreen-files',
        component: PrescreenFileIndex,
        meta: {
          title: 'Prescreen Files',
          permission: 'view prescreen::file-list',
        },
      },
      {
        path: 'prescreen-file/:id',
        name: 'prescreen-file',
        component: PrescreenFileDetails,
        meta: {
          title: 'Prescreen File Details',
          permission: 'view prescreen::file',
        },
      },
    ],
  },
];
